// src/components/analytics/StatusFunnel.tsx
import React from "react";
import { Paper, Box, Typography, Tooltip, alpha, useTheme } from "@mui/material";
import { TopLevelPaper } from "../../../../../../../themes/StyledComponents";

interface Props {
  totalBills: number;
  billsStarted: number;
  billsInProgress: number;
  billsCompleted: number;
}

const StatusFunnel: React.FC<Props> = ({
  totalBills,
  billsStarted,
  billsInProgress,
  billsCompleted,
}) => {
  const theme = useTheme();

  const stages = [
    {
      label: "Gestartet",
      count: billsStarted,
      color: "#ffffff", // dark blue
    },
    {
      label: "In Bearbeitung",
      count: billsInProgress,
      color: "#517896", // light blue
    },
    {
      label: "Abgeschlossen",
      count: billsCompleted,
      color: "#1B3C53", // very dark blue
    },
  ];

  const total = stages.reduce((s, x) => s + x.count, 0) || 1; // avoid /0

  return (
    <TopLevelPaper
      elevation={2}
      sx={{
        p: 2,
        mb: 1,
        border: "0px",
      }}
    >
      <Typography
        variant="subtitle2"
        fontWeight={450}
        mb={1.2}
      >
        Aktueller Abrechnungsstatus
      </Typography>

      {/* bar */}
      <Box
        sx={{
          display: "flex",
          height: 12,
          borderRadius: 1,
          overflow: "hidden",
          boxShadow: `inset 0 0 0 1px ${alpha(theme.palette.grey[400], 0.3)}`,
        }}
      >
        {stages.map((s) => (
          <Tooltip
            title={`${s.label}: ${s.count} (${((s.count / total) * 100).toFixed(1)} %)`}
            key={s.label}
          >
            <Box
              sx={{
                flexGrow: s.count,
                bgcolor: s.color,
                transition: "flex-grow .3s",
              }}
            />
          </Tooltip>
        ))}
      </Box>

      {/* legend line */}
      <Box
        display="flex"
        justifyContent="space-between"
        flexWrap="wrap"
        gap={1}
        mt={1}
      >
        {stages.map((s) => (
          <Box
            key={s.label}
            sx={{ display: "flex", alignItems: "center", gap: 0.5, minWidth: 120 }}
          >
            <Box
              sx={{
                width: 12,
                height: 12,
                bgcolor: s.color,
                borderRadius: 0.5,
              }}
            />
            <Typography variant="caption">
              {s.label}: {s.count}
            </Typography>
          </Box>
        ))}
      </Box>
    </TopLevelPaper>
  );
};

export default StatusFunnel;
